/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AIDataset,
    AIDatasetFromJSON,
    AIDatasetFromJSONTyped,
    AIDatasetToJSON,
    AIModel,
    AIModelFromJSON,
    AIModelFromJSONTyped,
    AIModelToJSON,
} from './';

/**
 * 
 * @export
 * @interface AIMetadata
 */
export interface AIMetadata {
    /**
     * 
     * @type {number}
     * @memberof AIMetadata
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof AIMetadata
     */
    asset: number;
    /**
     * 
     * @type {AIDataset}
     * @memberof AIMetadata
     */
    dataset: AIDataset;
    /**
     * 
     * @type {AIModel}
     * @memberof AIMetadata
     */
    model: AIModel;
    /**
     * 
     * @type {string}
     * @memberof AIMetadata
     */
    type?: AIMetadataTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof AIMetadata
     */
    metadata: object;
}

/**
* @export
* @enum {string}
*/
export enum AIMetadataTypeEnum {
    Null = 'null',
    Transcript = 'transcript',
    Visual = 'visual'
}

export function AIMetadataFromJSON(json: any): AIMetadata {
    return AIMetadataFromJSONTyped(json, false);
}

export function AIMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AIMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'asset': json['asset'],
        'dataset': AIDatasetFromJSON(json['dataset']),
        'model': AIModelFromJSON(json['model']),
        'type': !exists(json, 'type') ? undefined : json['type'],
        'metadata': json['metadata'],
    };
}

export function AIMetadataToJSON(value?: AIMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'asset': value.asset,
        'dataset': AIDatasetToJSON(value.dataset),
        'model': AIModelToJSON(value.model),
        'type': value.type,
        'metadata': value.metadata,
    };
}


